<select [(value)]='nrSelect' #option (change)="onChange($event, option.value)" class='select-item'>
    <option value='None'>None</option>
    <option value='Read'>Read</option>
    <option value='Write'>Write</option>
    <option value='Read/Write'>Read/Write</option>
</select>